// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalSearch_container__fFS43","searchIcon":"GlobalSearch_searchIcon__TA2Cq","crossIcon":"GlobalSearch_crossIcon__2yTm-"};